import { Injectable } from '@angular/core';
import { ConfigurationsService } from '@icc/configurator/shared';
import { ProfileSetsService } from '@icc/construction-elements/configurator';
import { EventBusService, TranslateService } from '@icc/shared';
import { DoorActiveConfiguration } from '@icc/window-door/types';
import { InfoService } from '@icc/shared/helpers';
import { FillingsService } from './modules/glazings/fillings.service';
import { WarmEdgesService } from './modules/glazings/warm-edges.service';
import { HandlesService } from './modules/handles/handles.service';
import { LocksService } from './modules/door/locks.service';
import { BrowserProfileSetsService } from './profiles/profile-sets.service';
import { NewColorsService } from '@icc/construction-elements/configurator';

@Injectable({
    providedIn: 'root',
})
export class DefaultConfigurationsService {
    constructor(
        private configurationsService: ConfigurationsService<'window'>,
        private fillingsService: FillingsService,
        private warmEdgeService: WarmEdgesService,
        private translateService: TranslateService,
        private infoService: InfoService,
        private handlesService: HandlesService,
        private locksService: LocksService,
        private newColorsService: NewColorsService,
        private profileSetsService: ProfileSetsService,
        private browserProfileSetsService: BrowserProfileSetsService
    ) {}

    isDefaultConfigurationAvailable(conf = this.configurationsService.conf?.Current) {
        return (
            conf?.System?.default_market_configuration &&
            (conf.System.default_market_configuration?.glass_type_id ||
                conf.System.default_market_configuration?.window_warm_edge_id ||
                conf.System.default_market_configuration?.window_handler_id ||
                conf.System.default_market_configuration?.single_door_lock_id ||
                conf.System.default_market_configuration?.double_door_lock_id ||
                conf.System.default_market_configuration?.window_color_id)
        );
    }

    setDefaultConfigurations(
        conf = this.configurationsService.conf.Current,
        defaultConf = this.configurationsService.conf.Default
    ) {
        if (!conf.System?.default_market_configuration) return;

        if (conf.System.default_market_configuration?.window_color_id) {
            this.newColorsService.resetWindowColors(conf);
        }

        if (conf.System.default_market_configuration?.profile_set_id) {
            const defaultProfileSet = this.browserProfileSetsService.getDefaultSet(
                conf,
                defaultConf
            );
            if (defaultProfileSet) {
                this.browserProfileSetsService.setSet(conf, defaultConf, defaultProfileSet, true);
            }
        }

        if (conf.System.default_market_configuration?.glass_type_id) {
            this.fillingsService.setDefaultGlassForSystem(conf, defaultConf);
        }

        if (conf.System.default_market_configuration?.window_warm_edge_id) {
            this.warmEdgeService.setDefaultWarmEdge(conf, defaultConf, false, true);
        }

        if (conf.System.default_market_configuration?.window_handler_id) {
            this.handlesService.setHandleType(conf.HandleType, conf);
        }

        if (
            conf.System.default_market_configuration?.single_door_lock_id ||
            conf.System.default_market_configuration?.double_door_lock_id
        ) {
            this.locksService.setDefaultLock(
                conf as DoorActiveConfiguration,
                defaultConf as DoorActiveConfiguration
            );
        }
    }

    confirmSettingDefaultConfiguration() {
        this.infoService.openConfirmModal(
            this.translateService.instant('WINDOW|Ustawienia domyślne'),
            this.translateService.instant(
                'WINDOW|Czy zastosować ustawienia domyślne dla wybranej linii produktowej? Obecne ustawienia zostaną zresetowane.'
            ),
            [
                {
                    name: this.translateService.instant('INTERFACE|Tak'),
                    callback: () => {
                        this.setDefaultConfigurations();
                    },
                },
                {
                    name: this.translateService.instant('INTERFACE|Nie'),
                    callback: () => {
                        return;
                    },
                },
            ]
        );
    }
}
